module.exports = __webpack_public_path__ + "img/petitions.99ec0f1e.svg";